import React from 'react';
import { useTranslation } from 'react-i18next';
import { IconButton, Sprite } from '@agissc/ktag-map';

interface DummyTopicLayerProps {
  topicLayerName?: string;
  onRemove: () => void;
}

const DummyTopicLayer = ({ topicLayerName, onRemove }: DummyTopicLayerProps) => {
  const { t } = useTranslation('agisviewer');

  return (
    <>
      <div title={t('layer_notavailable_tooltip')}>
        <div className="topic-layer__item-title-container topic-layer__item-title-container--disabled">
          <Sprite additionalClassNames="topic-layer__error-icon" id="attention" />
          <b>{t('layer_notavailable')}</b>
        </div>
        <div className="topic-layer__item-map-type">{topicLayerName}</div>
      </div>
      <IconButton
        onClick={onRemove}
        icon="wastebin"
        title={t('remove_topic_layer')}
        additionalClassNames="topic-layer__item-button"
      />
    </>
  );
};

export default DummyTopicLayer;
